module.exports = __webpack_public_path__ + "img/album17_11.67908f98.jpg";